import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { getUserProfileLink } from '../../services/userService';

interface UserLinkProps {
    uid: string;
    username?: string | null;
    displayName?: string | null;
    className?: string;
    children?: ReactNode;
}

/**
 * Reusable Link component that points to a user's public profile.
 * Falls back gracefully if the username is not available.
 */
export default function UserLink({
    uid,
    username,
    displayName,
    className,
    children,
}: UserLinkProps) {
    const profileUrl = getUserProfileLink(uid, username);
    const linkText = children ?? displayName ?? username ?? uid;
    return (
        <Link className={className} to={profileUrl}>
            {linkText}
        </Link>
    );
}
